export default function snakeCaseToCamelCase(name) {
  return name && name.replace(/_(\w)/g, function (_, b) {
    return b.toUpperCase();
  });
}
//# sourceMappingURL=snake-case-to-camel-case.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/payment/lib/esm/utilities/snake-case-to-camel-case.js
// module id = 603
// module chunks = 0 1